import Widget from "components/widget/Widget";
import SearchField from "components/fields/SearchField";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { FaAngleDown } from "react-icons/fa6";
import { Link } from "react-router-dom";
import NftIcon from "assets/img/icons/nft.png";
import VerifiedIcon from "assets/img/icons/verified.png";
import CollectionIcon from "assets/img/icons/collection.png";
import VolumeIcon from "assets/img/icons/volume.png";
import ListFilledIcon from "assets/img/icons/list_filled.png";
import TradingIcon from "assets/img/icons/trading.png";
import { HiOutlineLightBulb } from "react-icons/hi";

const Nft = () => {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container py-6">
          <div className="w-full px-5">
            <div className="w-full flex items-center ">
              <div className="md:flex justify-between w-full md:py-6">
                <p className="relative text-header text-white md:mb-0 mb-4">NFT Collections</p>
                <SearchField
                  extra="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                  id="email"
                  type="text"
                />
              </div>
            </div>
            <div className="w-full flex text-center mt-3 md:mt-1">
              <div className="ml-auto mr-auto md:mr-0 flex gap-4">
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Buy <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Exchange <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Play <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-6 md:mt-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden 2xl:px-[80px]">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 py-5 gap-4">
            <Widget
                icon={<img
                    className="w-7 h-7"
                    src={CollectionIcon}
                    alt=""
                />}
                title={"Collections"}
                border="sm:border-r-[1px]"
                subtitle={<span>255,471 <span className="text-gray-700 dark:text-gray-300">(40,547 NFTs)</span></span>}
              />
              <Widget
                icon={<img
                  className="w-7 h-7"
                  src={VolumeIcon}
                  alt=""
                />}
                title={"24H Volume"}
                border="xl:border-r-[1px]"
                subtitle={<span>100,000.00 BBA <span className="text-green-600">(+62.54%)</span></span>}
              />
              <Widget
                icon={<img
                  className="w-7 h-7"
                  src={ListFilledIcon}
                  alt=""
                />}
                title={"24H NFT Listing"}
                border="sm:border-r-[1px]"
                subtitle={<span>1,457 <span className="text-green-600">(+62.54%)</span></span>}
              />
              <Widget
                icon={<img
                  className="w-7 h-7"
                  src={TradingIcon}
                  alt=""
                />}
                title={"24H Trading"}
                border="border-none"
                subtitle={<span>2,524 <span className="text-green-600">(+62.54%)</span></span>}
              />
            </div>
          </div>
        </div>
        <div className="mt-6 mb-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden">
            <div className="flex flex-col mt-5 border-b-[1px] border-gray-100 dark:border-lightGrey 2xl:mx-5">
              <div className="flex gap-1 flex-row items-center justify-between flex-wrap px-2.5 md:px-5 2xl:px-0 w-full py-4">
                <div className="not-italic text-large">
                More than 280,993 NFT Collections Found
                </div>
              </div>
            </div>
            <div className="table-wrapper">
              <table className="table w-full">
                <thead>
                  <tr className="border-none">
                    <th className="w-[5px] !min-w-0 !pr-0 2xl:!pl-5">#</th>
                    <th className="">Collection</th>
                    <th className="">Volume</th>
                    <th className="">Floor Price</th>
                    <th className="">Change(%)</th>
                    <th className="">Assets</th>
                    <th className="2xl:!pr-5">Txn Count</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Array(4).fill(0).map((data, index) => <tr>
                      <td className="2xl:!pl-5">{index + 1}</td>
                      <td className="">
                        <Link to="/collection/01" className="text-green-900 text-small truncate flex items-center gap-1">
                          <img
                            src={NftIcon}
                            className="rounded-[4px] w-6 h-6"
                            alt=""
                          />
                          Owl Bridge
                          <img
                            src={VerifiedIcon}
                            className="w-4 h-4 ml-0.5"
                            alt=""
                          />
                        </Link>
                      </td>
                      <td>
                        <p className="text-small">541,658.35684 BBA</p>
                      </td>
                      <td>
                        <p className="text-small">0.01 BBA</p>
                      </td>
                      <td>
                        <p className="text-small text-green-900">11.54%</p>
                      </td>
                      <td>
                        <p className="text-small">3,333</p>
                      </td>
                      <td className="2xl:!pr-5">
                        <p className="text-small">200,524 BBA</p>
                      </td>
                    </tr>)
                  }
                  
                </tbody>
              </table>
            </div>
            <div className="p-5 justify-center md:justify-between flex mb-2">
              <div className="md:flex gap-2 hidden">
                <span className="text-small flex items-center">Show</span>
                <select className="text-small">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>100</option>
                </select>
                <span className="text-small flex items-center">Per Page</span>
              </div>
              <div className="flex gap-2">
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                <span className="text-small flex items-center px-2">Page 1 of 25</span>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
              </div>
            </div>
          </div>
          <div className="text-gray-700 dark:text-gray-300 text-xsmall flex items-center mt-5">
            <span className="text-large mr-1 mb-1"><HiOutlineLightBulb /></span>
            <span>
            A transaction refers to a cryptographically validated command that alters the state of the blockchain. Block explorers monitor the specifics of every transaction occurring within the network. Discover more about transactions in our
              <span className="text-green-900 ml-1">Knowledge Hub</span>.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nft;
